<template>
    <div>
        <b-card no-body class="mb-1">
            <v-table    ref="table" 
                        :fields="fields"
                        with-items
                        :items="datas"
                        pagination="client"
                        :settings="false">
                        <template #additional-actions>
                            <div class="row">
                                <div class="col-md-3 mb-1 mb-md-0">             
                                    <b-input-group class="input-group-merge">
                                        <template #prepend>
                                            <b-input-group-text >
                                                <feather-icon icon="SearchIcon"></feather-icon>
                                            </b-input-group-text>
                                        </template>
                                        <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                                    </b-input-group>
                                </div>
                                <div class="col-md-auto mb-1 mb-md-0">
                                    <button class="btn btn-success btn-block" v-on:click="getData" :disabled="getting">
                                        Sorgula
                                    </button>
                                </div>
                                <div class="col-md-auto ml-auto">
                                    <b-dropdown text="İşlemler" right variant="primary" v-if="excelPath">
                                        <b-dropdown-item v-on:click="downloadExcel">
                                            <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                            Excel İndir
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                            </div>
                        </template>
                    </v-table>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>

</template>

<script>
import { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'

export default{
    components:{
        BCard,
        BInputGroup, 
        BInputGroupText, 
        BFormInput,
        BDropdown, 
        BDropdownItem
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
    },
    data(){
        return {
            fields:[
                {name:'Referans Numarası',key:'RefCode',tdClass:'text-nowrap'},
                {name:'Ad Soyad',key:'EmployeeFullName',tdClass:'text-nowrap',thClass:'w-70'},
                {name:'Tutar',key:'AmountStr',tdClass:'text-nowrap',thClass:'w-15'},
                {name:'Hata',key:'Error',tdClass:'text-nowrap',thClass:'w-15'}
            ],
            datas:[],
            excelPath:null,
            searchValue:'',
            getting:false
        }
    },
    methods:{
        getData(){
                    this.$refs.table.setLoading(true)
                    this.getting = true
                    EmployeeOperationsApi.GSalary.TicketExcel({
                        ...this.filter,
                        PaginateRequest:{
                            QueryParam: this.searchValue
                        }
                    }).then(res => {
                        if(res.data.Success){
                            this.datas = res.data.Data.Data.Data
                            this.excelPath = res.data.Data.ExcelPath
                        }else{
                            this.$result(res)
                        }
                        this.$refs.table.setLoading(false)
                        this.getting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.$refs.table.setLoading(false)
                        this.getting = false
                    })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    }
}
</script>